export default __webpack_public_path__ + "static/media/minha_conta.7c31bb48.png";